import React from 'react';
import { LoginContext } from "../Providers/LoginContextProvider"
import { Redirect } from 'react-router-dom';

//const withAuthorized:<T extends {}>(wrappedComponent: React.FC<T>) => React.FC<T> = (wrappedComponent) => {
const withAuthorized = <P extends {}>(AuthComponent: React.ComponentType<P>, UnauthComponent?: React.ComponentType<P> | undefined) => (
    class WithAuthorized extends React.Component<P> {
        
        static contextType = LoginContext

        render() {
            const {...props} = this.props;
            const { ready, login }: {ready: boolean, login: boolean} = this.context;

            return (
                <LoginContext.Consumer>
                    { (v)=>{
                        console.log(v)
                        return !ready 
                            ? null
                            : login
                                ? <AuthComponent {...props} />
                                : UnauthComponent 
                                    ? <UnauthComponent {...props} />
                                    : <Redirect push to={`/404?redirect=${encodeURIComponent(window.location.pathname)}`} />
                    }

                    }
                </LoginContext.Consumer>
            )
        }
    }
)

export default withAuthorized